import {Schema, useUrlFilters} from '../useUrlFilters';
import type {SelectedInputGroup} from './types/filters.type';
export interface AdvertisementFilters {
  search: string;
  input_group_guid: SelectedInputGroup[];
  input_guid: SelectedInputGroup[];
  order_by: string;
  has_immediate: boolean;
  has_special_offer: boolean;
  has_store: boolean;
  has_price: boolean;
  start_price?: number;
  end_price?: number;
}

const defaultSchema: Schema<AdvertisementFilters> = {
  search: {type: 'string', default: ''},
  input_group_guid: {type: 'json', default: []},
  input_guid: {type: 'json', default: []},
  order_by: {type: 'string', default: ''},
  has_immediate: {type: 'boolean', default: false},
  has_special_offer: {type: 'boolean', default: false},
  has_store: {type: 'boolean', default: false},
  has_price: {type: 'boolean', default: false},
  start_price: {type: 'number', default: undefined},
  end_price: {type: 'number', default: undefined},
};

export function useAdvertisementFilters() {
  const {values, setFilter, setFilters, resetFilter, reset} =
    useUrlFilters<AdvertisementFilters>(defaultSchema);

  return {
    filters: values,
    setFilter,
    setFilters,
    resetFilter,
    reset,
  };
}
